import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import mixpanel from "mixpanel-browser";
import { Badge, Box, Button, Card, Text, Icon, Grid, Dropdown } from "~/components-shared";
import lists from "~/lib/lists";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { TrendReportActionEnum } from "~/store/trendReports/types";
import { useDispatch } from "react-redux";
import trendReportsActionCreators from "~/store/trendReports/actions";
import TrendingItemCard from "~/components/insightsWidgets/TrendingItemCard";
import StyledIcon from "~/components/StyledIcon";
const StyledBox = styled(Box)`
  overflow: auto;
  height: 100%;
  position: relative;
  width: calc(100% + ${_ref => {
  let {
    theme
  } = _ref;
  return 10 / (theme.typography.fontSize / theme.spacing.step);
}}rem);

  &::-webkit-scrollbar {
    margin-left: 200px;
    width: 4px;
    height: 8px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.grey.main;
}};
    margin-left: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return 5 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
    margin-right: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return 5 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
  }
`;
const BoxWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  width: 100%;

  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    width: 20px;
    height: calc(100% - 10px);
    top: 0;
    right: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return -5 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
    background: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.gradients.background(90);
}};
  }
`;
const TrendingCard = _ref7 => {
  let {
    widget,
    ...rest
  } = _ref7;
  const {
    t
  } = useTranslation();
  const {
    byType,
    items
  } = widget.data;
  const [showDismissed, setShowDismissed] = React.useState(false);
  const [selectedType, setSelectedType] = React.useState("all");
  const filteredDismissed = items.filter(item => showDismissed || !item.isDismissed);
  const filteredItems = filteredDismissed.filter(item => selectedType === "all" || selectedType === item.workType);
  const dispatch = useDispatch();
  const handleOverview = (reportId, trendId) => {
    dispatch(trendReportsActionCreators.actionChanged(TrendReportActionEnum.OVERVIEW, reportId, trendId));
    mixpanel.track(`Insights Trending – Overview`, {
      reportId,
      trendId
    });
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    align: "left"
  }, rest), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 3
    }
  }, t("TrendingCard.whatsTrending")), filteredDismissed.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr auto",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box, {
    gap: 2,
    s: {
      mb: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    fontSize: 3.4,
    s: {
      py: 1,
      pr: 1,
      pl: 3
    },
    color: selectedType === "all" ? "translucentPrimary" : "transparent",
    onClick: () => setSelectedType("all"),
    outline: false
  }, "All", /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2,
      ml: 1
    },
    color: "translucent"
  }, Object.values(byType).reduce((prev, curr) => prev + curr, 0))), Object.keys(byType).map(key => /*#__PURE__*/React.createElement(Button, {
    key: key,
    fontSize: 3.4,
    s: {
      py: 1,
      pr: 1,
      pl: 3
    },
    color: selectedType === key ? "translucentPrimary" : "transparent",
    onClick: () => setSelectedType(key),
    outline: false
  }, lists.insights.workTypes.names[key], /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2,
      ml: 2
    },
    color: "translucent"
  }, byType[key])))), /*#__PURE__*/React.createElement(Dropdown, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("common.actions.options"),
    display: "inline-block",
    direction: "bottomLeft",
    handlerProps: {
      color: showDismissed ? "translucentPrimary" : "transparent",
      rounded: true,
      s: {
        p: 1
      }
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      display: "block",
      src: "filter"
    })
  }, _ref8 => {
    let {
      isOpen,
      onItemClick
    } = _ref8;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        setShowDismissed(prev => !prev);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: showDismissed ? "checkboxFill" : "checkbox",
      s: {
        mr: 2
      },
      color: "primary"
    }), "Show Dismissed"));
  })), /*#__PURE__*/React.createElement(BoxWrapper, null, /*#__PURE__*/React.createElement(StyledBox, {
    wrap: "nowrap",
    align: "stretch",
    gap: 5,
    s: {
      px: 5,
      pb: 5,
      mx: -5
    }
  }, filteredItems.map(item => /*#__PURE__*/React.createElement(TrendingItemCard, {
    width: "328px",
    onClick: () => handleOverview(item.reportId, item.id),
    key: item.id,
    color: "translucent",
    align: "left",
    item: item,
    showDismissed: showDismissed
  }))))) : /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center",
    fullHeight: true,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "discovery",
    color: "translucentInfo"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "300px"
    }
  }, "No Product Specific Trends")));
};
export default TrendingCard;